module.exports = __webpack_public_path__ + "img/bodycheck4.c8626140.jpg";